import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pt-10" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h1 class=\"anchor fw-bolder mb-5\" id=\"basic\"><a href=\"#basic\"></a> Basic Example </h1><div class=\"py-5\"> Use slightly customized pagination with previouse and next icon links: </div><div class=\"py-5\"><div class=\"rounded border p-10\"><ul class=\"pagination\"><li class=\"page-item previous\"><a href=\"#\" class=\"page-link\"><i class=\"ki ki-arrow-back\"></i></a></li><li class=\"page-item \"><a href=\"#\" class=\"page-link\">1</a></li><li class=\"page-item active\"><a href=\"#\" class=\"page-link\">2</a></li><li class=\"page-item \"><a href=\"#\" class=\"page-link\">3</a></li><li class=\"page-item \"><a href=\"#\" class=\"page-link\">4</a></li><li class=\"page-item \"><a href=\"#\" class=\"page-link\">5</a></li><li class=\"page-item \"><a href=\"#\" class=\"page-link\">6</a></li><li class=\"page-item next\"><a href=\"#\" class=\"page-link\"><i class=\"ki ki-arrow-next\"></i></a></li></ul></div></div>", 3)
const _hoisted_5 = { class: "py-5" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(`
        <ul class="pagination">
          <li class="page-item previous">
            <a href="#" class="page-link"><i class="ki ki-arrow-back"></i></a>
          </li>
          <li class="page-item "><a href="#" class="page-link">1</a></li>
          <li class="page-item active"><a href="#" class="page-link">2</a></li>
          <li class="page-item "><a href="#" class="page-link">3</a></li>
          <li class="page-item "><a href="#" class="page-link">4</a></li>
          <li class="page-item "><a href="#" class="page-link">5</a></li>
          <li class="page-item "><a href="#" class="page-link">6</a></li>
          <li class="page-item next">
            <a href="#" class="page-link"><i class="ki ki-arrow-next"></i></a>
          </li>
        </ul>
        `))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      })
    ])
  ]))
}